import type { SxProps, Theme } from '@mui/material/styles';
import { cardSx as openXAgentCardSx } from '../../MatchesDetails/shared/utils/styles.ts';
import { STATUS_COLORS, type StatusTone } from '../utils/statusTonePalette.ts';
import { columnSx, listResetSx } from '../utils/styles.ts';

export const disclaimerSx: SxProps<Theme> = {
  m: 0,
  fontSize: 14,
  lineHeight: '20px',
  color: 'text.primary',
};

export const disclaimerLabelSx: SxProps<Theme> = { fontWeight: 'fontWeightBold' };

// together with the column gap above it, gives the 32px Figma puts between the disclaimer and a section
export const sectionSx: SxProps<Theme> = { ...columnSx, mt: 2.5 };

export const personaListSx: SxProps<Theme> = { ...columnSx, ...listResetSx };

export const sectionTitleSx = (tone: StatusTone): SxProps<Theme> => ({
  m: 0,
  fontSize: 16,
  lineHeight: '28px',
  fontWeight: 'fontWeightBold',
  color: STATUS_COLORS[tone].accent,
});

export const sectionCaptionSx: SxProps<Theme> = { m: 0, fontSize: 10, lineHeight: '14px', color: 'text.secondary' };

export const cardSx = (tone: StatusTone): SxProps<Theme> => ({
  ...openXAgentCardSx,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  py: 2,
  px: 3,
  borderColor: STATUS_COLORS[tone].accent,
});

export const cardHeaderSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 1 };

export const avatarSx: SxProps<Theme> = { fontSize: 36, flexShrink: 0 };

export const cardTitleSx: SxProps<Theme> = {
  m: 0,
  fontSize: 16,
  lineHeight: '22px',
  fontWeight: 'fontWeightBold',
  color: 'text.primary',
};

export const cardDescriptionSx: SxProps<Theme> = { m: 0, fontSize: 14, lineHeight: '20px', color: 'text.secondary' };

export const reasonsSx = (tone: StatusTone): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  m: 0,
  fontSize: 14,
  lineHeight: '20px',
  color: STATUS_COLORS[tone].strong,
  '& .MuiSvgIcon-root': { fontSize: 22, flexShrink: 0, color: STATUS_COLORS[tone].accent },
});
